module.exports = __webpack_public_path__ + "img/image4.b888fcfe.jpg";